module.exports = __webpack_public_path__ + "static/media/middle-none-4.d63bd9d7.png";